/**
 * properties-panel-ref-store.ts — Standalone Zustand store exposing the
 * properties-panel root DOM element for D-050-02 focus-precedence checks
 * inside `usePreviewSelection`'s click handler.
 *
 * Phase 050 Cross-cutting (b) Path 1 (PATTERNS.md RECOMMENDED) — mirrors
 * `preview-selection-slice.ts` byte-for-byte: standalone `create<>()()`,
 * no `persist` middleware, callback-ref `setPanelElement` action.
 *
 * Consumer pattern (imperative read, matches Phase 048/049 listener idiom):
 *   const panelEl = usePropertiesPanelRefStore.getState().panelElement
 *   const active = document.activeElement
 *   const panelHasFocus =
 *     panelEl !== null && active !== null && panelEl.contains(active)
 *   if (!panelHasFocus) container.focus()
 *
 * Reset on page reload — natural for transient editor state. No persist.
 */
import { create } from 'zustand'

interface PropertiesPanelRefState {
  panelElement: HTMLElement | null
  setPanelElement: (el: HTMLElement | null) => void
  reset: () => void
}

const initialState = {
  panelElement: null as HTMLElement | null,
}

export const usePropertiesPanelRefStore = create<PropertiesPanelRefState>()(
  (set, _get) => ({
    ...initialState,
    setPanelElement: (panelElement) => set({ panelElement }),
    reset: () => set({ ...initialState }),
  }),
)
